export default __webpack_public_path__ + "static/underwear-results-4-87c9a88fc816744d3f9f9e48a6f89305.png";